// components/CompetitionDetails.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useCompetition } from '../contexts/CompetitionContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Plus, Users, ClipboardList, Play, BarChart3, Settings, Calendar, MapPin, Clock, Trophy, ArrowLeft } from 'lucide-react';
import { getCompetitionById, getJudges } from '../services/apiServices';

export const CompetitionDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const { competitionId } = useParams();
    const { competitions, updateCompetitionStatus, loading } = useCompetition();
    const [competition, setCompetition] = useState(null)
    // Find the specific competition
    // const competition = competitions.find(comp => comp.id === competitionId);

    useEffect(() => {
        async function fetchCompetition() {
            try {
                let organiserId = JSON.parse(localStorage.getItem("loggedAdminInfo")) ? JSON.parse(localStorage.getItem("loggedAdminInfo")).organizerId : "";
                const response = await getCompetitionById(location.state?._id);

                if (!response || response === "false") {
                    return;
                } else {
                    const competitionData = await response.json();
                    console.log(competitionData, 'hvdfhdhb');

                    setCompetition(competitionData)
                }
            } catch (error) {
                console.error("Error fetching climbers:", error);
            }
        }
        if (location.state?._id) {
            fetchCompetition();
        }
    }, [location.state]);

    const getStatusColor = (status) => {
        switch (status) {
            case 'setup': return 'bg-gray-500';
            case 'ready': return 'bg-blue-500';
            case 'countdown': return 'bg-blue-500';
            case 'running': return 'bg-green-500';
            case 'paused': return 'bg-yellow-500';
            case 'completed': return 'bg-purple-500';
            case 'active': return 'bg-green-500';
            case 'upcoming': return 'bg-blue-500';
            default: return 'bg-gray-500';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'setup': return 'SETUP';
            case 'ready': return 'READY';
            case 'countdown': return 'COUNTDOWN';
            case 'running': return 'RUNNING';
            case 'paused': return 'PAUSED';
            case 'completed': return 'COMPLETED';
            case 'active': return 'ACTIVE';
            case 'upcoming': return 'UPCOMING';
            default: return status.toUpperCase();
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Not set';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (error) {
            return dateString;
        }
    };

    const getJudgesAssigned = (comp) => {
        const totalBoulders = comp.numberOfBoulders || comp.boulders?.length || 0;
        let uniqueJudges = new Set();

        if (comp.boulders && Array.isArray(comp.boulders)) {
            comp.boulders.forEach(boulder => {
                if (boulder.judgeId && boulder.judgeId !== '') {
                    uniqueJudges.add(boulder.judgeId);
                }
            });
        }

        const assignedJudgesCount = uniqueJudges.size;
        return `${assignedJudgesCount}/${totalBoulders}`;
    };
    console.log(competition, 'competition');


    // Loading state
    if (loading) {
        return (
            <div className="min-h-screen p-4 md:p-6 max-w-6xl mx-auto">
                <div className="flex items-center justify-center h-64">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                        <p className="mt-4 text-gray-600">Loading competition details...</p>
                    </div>
                </div>
            </div>
        );
    }

    // Competition not found
    if (!competition) {
        return (
            <div className="min-h-screen p-4 md:p-6 max-w-6xl mx-auto">
                <div className="space-y-6">
                    <div className="flex items-center gap-4">
                        <Button
                            variant="outline"
                            onClick={() => navigate('/dashboard')}
                            className="flex items-center gap-2"
                        >
                            <ArrowLeft className="size-4" />
                            Back to Dashboard
                        </Button>
                    </div>
                    <Card>
                        <CardContent className="flex flex-col items-center justify-center py-16">
                            <Trophy className="size-16 text-gray-400 mb-4" />
                            <h3 className="text-xl font-semibold text-gray-600 mb-2">Competition not found</h3>
                            <p className="text-gray-500 text-center mb-6">
                                The competition you're looking for doesn't exist or you don't have access to it.
                            </p>
                            <Button
                                onClick={() => navigate('/dashboard')}
                                className="flex items-center gap-2"
                            >
                                <ArrowLeft className="size-4" />
                                Back to Dashboard
                            </Button>
                        </CardContent>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen p-4 md:p-6 max-w-6xl mx-auto">
            <div className="space-y-6">
                {/* Header */}
                <div className="space-y-2">
                    <div className="flex justify-between items-start">
                        <div className="flex items-start gap-4">
                            <Button
                                variant="outline"
                                onClick={() => navigate('/dashboard')}
                                className="flex items-center gap-2"
                            >
                                <ArrowLeft className="size-4" />
                                Back
                            </Button>
                            <div>
                                <h1 className="text-3xl font-bold">{competition?.name || "UnKnown Name"}</h1>
                                <div className="flex items-center gap-2 mt-1">
                                    <p className="text-gray-600">
                                        {formatDate(competition.startDate)}
                                    </p>
                                    <Badge className={getStatusColor(competition?.status)}>
                                        {getStatusText(competition?.status)}
                                    </Badge>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Competition Overview */}
                <Card>
                    <CardHeader>
                        <CardTitle>Competition Overview</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="text-center">
                                <p className="text-2xl font-bold">{competition?.numberofboulders}</p>
                                <p className="text-sm text-gray-600">Boulders</p>
                            </div>
                            <div className="text-center">
                                <p className="text-2xl font-bold">{competition?.competitors?.length || 0}</p>
                                <p className="text-sm text-gray-600">Competitors</p>
                            </div>
                            <div className="text-center">
                                <p className="text-2xl font-bold">{competition?.climbTime}s</p>
                                <p className="text-sm text-gray-600">Climb Time</p>
                            </div>
                            <div className="text-center">
                                <p className="text-2xl font-bold">{getJudgesAssigned(competition)}</p>
                                <p className="text-sm text-gray-600">Judges Assigned</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Additional Competition Info */}
                <Card>
                    <CardHeader>
                        <CardTitle>Competition Information</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <p className="text-sm text-gray-600">Category</p>
                                <p className="font-semibold">{competition?.category || 'Not specified'}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Type</p>
                                <p className="font-semibold">{competition?.type || 'Standard'}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Start Date</p>
                                <p className="font-semibold">{competition.startDate ? formatDate(competition.startDate) : "--"}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">End Date</p>
                                <p className="font-semibold">{competition.endDate ? formatDate(competition.endDate) : "--"}</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Warning Time</p>
                                <p className="font-semibold">{competition?.warningTime ? competition.warningTime : "--"}s</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600">Wrap Time</p>
                                <p className="font-semibold">{competition?.wrapTime ? competition.wrapTime : "--"}s</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Boulder List */}
                {competition.boulders && competition.boulders.length > 0 && (
                    <Card>
                        <CardHeader>
                            <CardTitle>Boulders</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <div className="space-y-2">
                                {competition.boulders.map((boulder, index) => (
                                    <div key={boulder.id} className="flex justify-between items-center py-2 border-b last:border-b-0">
                                        <div>
                                            <p className="font-semibold">{boulder.name}</p>
                                            <p className="text-sm text-gray-600">Boulder {index + 1}</p>
                                        </div>
                                        <Badge variant={boulder.judgeId ? "default" : "secondary"}>
                                            {boulder.judgeId ? 'Judge Assigned' : 'No Judge'}
                                        </Badge>
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    </Card>
                )}

                {/* Quick Actions */}
                <div className="space-y-3">
                    <h2 className="text-xl font-semibold">Quick Actions</h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <>
                            <Card
                                className="cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => navigate('/create-round', {
                                    state: competition,
                                })}
                            >
                                <CardHeader className="flex flex-row items-center gap-4">
                                    <div className="bg-blue-100 p-3 rounded-lg">
                                        <Settings className="size-6 text-blue-600" />
                                    </div>
                                    <div>
                                        <CardTitle>Configure Round</CardTitle>
                                        <CardDescription>Edit boulders and settings</CardDescription>
                                    </div>
                                </CardHeader>
                            </Card>

                            <Card
                                className="cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => navigate('/sequence-editor', {
                                    state: competition,
                                })}
                            >
                                <CardHeader className="flex flex-row items-center gap-4">
                                    <div className="bg-purple-100 p-3 rounded-lg">
                                        <Users className="size-6 text-purple-600" />
                                    </div>
                                    <div>
                                        <CardTitle>Manage Competitors</CardTitle>
                                        <CardDescription>Add and sequence climbers</CardDescription>
                                    </div>
                                </CardHeader>
                            </Card>

                            <Card
                                className="cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => navigate('/judge-management', {
                                    state: competition,
                                })}
                            >
                                <CardHeader className="flex flex-row items-center gap-4">
                                    <div className="bg-indigo-100 p-3 rounded-lg">
                                        <Users className="size-6 text-indigo-600" />
                                    </div>
                                    <div>
                                        <CardTitle>Manage Judges</CardTitle>
                                        <CardDescription>Add judge information</CardDescription>
                                    </div>
                                </CardHeader>
                            </Card>

                            <Card
                                className="cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => navigate('/judge-assignment', {
                                    state: competition,
                                })}
                            >
                                <CardHeader className="flex flex-row items-center gap-4">
                                    <div className="bg-green-100 p-3 rounded-lg">
                                        <ClipboardList className="size-6 text-green-600" />
                                    </div>
                                    <div>
                                        <CardTitle>Assign Judges</CardTitle>
                                        <CardDescription>Set judge assignments</CardDescription>
                                    </div>
                                </CardHeader>
                            </Card>
                        </>

                        <Card
                            className="cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={() => navigate('/live-controller', {
                                state: competition,
                            })}
                        >
                            <CardHeader className="flex flex-row items-center gap-4">
                                <div className="bg-green-100 p-3 rounded-lg">
                                    <Play className="size-6 text-green-600" />
                                </div>
                                <div>
                                    <CardTitle>Live Controller</CardTitle>
                                    <CardDescription>Monitor and control the active round</CardDescription>
                                </div>
                            </CardHeader>
                        </Card>


                        <Card
                            className="cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={() => navigate('/results', {
                                state: competition,
                            })}
                        >
                            <CardHeader className="flex flex-row items-center gap-4">
                                <div className="bg-orange-100 p-3 rounded-lg">
                                    <BarChart3 className="size-6 text-orange-600" />
                                </div>
                                <div>
                                    <CardTitle>View Results</CardTitle>
                                    <CardDescription>See scores and export data</CardDescription>
                                </div>
                            </CardHeader>
                        </Card>




                    </div>
                </div>
            </div>
        </div>
    );
};